import { useMemo, useRef } from 'react';
import SettingsEditor from '@/components/settings/SettingsEditor';
import { platformGet, platformSend, errorOf } from './platformApi';

/** Platform console: one company's settings (routes/platformRouter.js /companies/:id/settings). */
export default function CompanySettingsTab({ company, act }) {
  // `act` is a fresh closure every render; reading it through a ref keeps `source` stable, so
  // the editor does not refetch on each render.
  const actRef = useRef(act);
  actRef.current = act;
  const source = useMemo(() => ({
    definitions: () => platformGet('/settings/definitions'),
    load: (branchId) => platformGet(`/companies/${company.id}/settings`, branchId ? { branchId } : undefined),
    save: (branchId, writes, expectedVersion) => actRef.current(() => platformSend('patch', `/companies/${company.id}/settings`, {
      branchId, expectedVersion, writes,
    }), 'Settings saved'),
    errorMessage: (ex) => errorOf(ex).message,
  }), [company.id]);
  return <SettingsEditor source={source} branches={company.branches} />;
}
